import React, { useState } from 'react'
import PropTypes from 'prop-types'

const UploadBox = ({ handleClick, onFileDrop, className, style, error }) => {
  const [isDragging, setIsDragging] = useState(false)

  const handleDragOver = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(true)
  }

  const handleDragLeave = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
  }

  const handleDrop = e => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFile = e.dataTransfer.files[0]
      onFileDrop(droppedFile)
      e.dataTransfer.clearData()
    }
  }

  return (
    <div
      className={`mt-4 w-full min-h-[144px] rounded-[16px] border-2 border-dashed transition-all duration-200
        ${
          error
            ? 'border-red-500 bg-[#1a1c25]'
            : isDragging
            ? 'border-purple-400 bg-[#1a1c25]'
            : 'border-[#686c74] bg-[#12141688]'
        }
        hover:border-purple-400 hover:bg-[#1a1c25] cursor-pointer
        flex items-center justify-center text-center ${className}`}
      onClick={handleClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={style}
    >
      <div className="flex flex-col items-center justify-center text-[#bbb]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 mb-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M16 10l-4-4m0 0l-4 4m4-4v12"
          />
        </svg>
        <p className="text-sm font-medium">Click or Drag & Drop Image</p>
      </div>
    </div>
  )
}

UploadBox.propTypes = {
  handleClick: PropTypes.func.isRequired,
  onFileDrop: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  error: PropTypes.bool
}

UploadBox.defaultProps = {
  className: '',
  style: {},
  error: false
}

export default UploadBox
